import { shouldUseAcmeMockData } from '@/lib/utils/shouldUseAcmeMockData'
import type { IOrganization } from '@/types/organization'

export interface IMonitoringVisibility {
  showSiem: boolean
  showEdr: boolean
}

// SIEM and EDR serve mock data to ACME and demo orgs, so both always see them
export default function getMonitoringVisibility(organization: IOrganization): IMonitoringVisibility {
  const hasMockData = shouldUseAcmeMockData(organization)
  return {
    showSiem: hasMockData || organization.hasSiemSidebar === true,
    showEdr: hasMockData,
  }
}
